$(window).load(function () {
   quicklinks('.quicklinks');
});